export type StockLevel = 'outOfStock' | 'low' | 'medium' | 'high';

/**
 * Maps a raw inventory count to the PDP stock-level tier.
 *
 * Counts of 0 or less — including negative on-hand caused by an in-store sale
 * against a reserved pickup unit (ED-499) — are out of stock.
 */
export const getStockLevel = (
  quantity: number | null | undefined
): StockLevel | false => {
  if (typeof quantity !== 'number' || Number.isNaN(quantity)) return false;
  if (quantity <= 0) return 'outOfStock';
  if (quantity < 5) return 'low';
  if (quantity <= 10) return 'medium';
  return 'high';
};

export default getStockLevel;
